<template>
  <div class="nav-wrapper">
    <ul class="nav nav-main">
      <li v-if="companyUser" :tooltip="$t('nav.containers')" flow="down">
        <Link to="/containers">
          <span class="material-icons">delete</span>
          <span class="nav-txt">{{ $t('nav.containers') }}</span>
        </Link>
      </li>
      <template v-if="companyType === 'branch'">
        <li :tooltip="$t('nav.containerGroups')" flow="down">
          <Link to="/container_groups">
            <span class="material-icons">share_location</span>
            <span class="nav-txt">{{ $t('nav.containerGroups') }}</span>
          </Link>
        </li>
        <li :tooltip="$t('nav.routes')" flow="down">
          <Link to="/routes">
            <span class="material-icons">map</span>
            <span class="nav-txt">{{ $t('nav.routes') }}</span>
          </Link>
        </li>
      </template>
      <li v-if="companyType === 'industry'" :tooltip="$t('nav.orders')" flow="down">
        <Link to="/orders">
          <span class="material-icons">list</span>
          <span class="nav-txt">{{ $t('nav.orders') }}</span>
        </Link>
      </li>
      <li v-if="companyUser" :tooltip="$t('nav.reporting')" flow="down">
        <Link to="/reporting">
          <span class="material-icons">analytics</span>
          <span class="nav-txt">{{ $t('nav.reporting') }}</span>
        </Link>
      </li>
    </ul>
    <ul class="nav nav-meta">
      <li class="nav-small">
        <Exports />
      </li>
      <li class="nav-small" v-if="companyUser">
        <Link :to="companyPath" :tooltip="$t('nav.companies')" flow="down">
          <span class="material-icons">business</span>
        </Link>
      </li>
      <li class="nav-small">
        <Link to="/user" :tooltip="$t('nav.account')" flow="down">
          <span class="material-icons">account_circle</span>
        </Link>
      </li>
      <li class="nav-small" v-if="companyUser">
        <Link to="/notifications" :tooltip="$t('nav.notifications')" flow="down">
          <span class="material-icons">circle_notifications</span>
        </Link>
      </li>
      <li v-if="companyUser.user_admin" class="nav-small">
        <Link to="/admin/users" tooltip="Admin" flow="down">
          <span class="material-icons">admin_panel_settings</span>
        </Link>
      </li>
      <li class="nav-small">
        <a @click="logoutUser" href="#" tooltip="Logout" flow="down">
          <span class="material-icons">exit_to_app</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Exports from '@/components/Exports.vue'

import { getRedirectPath } from '@/router'

export default {
  name: 'MainNav',
  inject: ['companyUser'],
  emits: ['logoutUser'],
  components: { Exports },
  methods: {
    logoutUser() {
      this.$emit('logoutUser')
    },
  },
  computed: {
    companyType() {
      return this.companyUser.company_type
    },
    companyPath() {
      return getRedirectPath(this.companyUser, '/company')
    },
  },
}
</script>

<style lang="scss">
.nav-wrapper {
  flex: 1;
  display: flex;
  max-width: calc(100% - 98px - 2rem);
  justify-content: space-between;
}

.nav {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;

  li {
    list-style-type: none;

    a {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      display: block;
      padding: 0.5rem 0.75rem;
      border-radius: var(--border-radius-m);
      white-space: nowrap;

      span {
        vertical-align: middle;
        display: inline-block;
      }

      .nav-txt {
        margin-left: 5px;
      }

      .nav-small-txt {
        margin-left: 2px;
        font-size: 0.8em;
        padding-top: 12px;
      }
    }

    a.Link-active {
      background: rgba(0, 0, 0, 0.15);
    }
  }

  li.nav-small {
    margin: 0 1rem;
  }
}

.nav-main {
  min-width: 0;

  li {
    min-width: 0;

    a {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &[tooltip]::before,
    &[tooltip]::after {
      display: none;
    }
  }
}

.nav-meta {
  min-width: auto;
  justify-content: end;
  padding-right: 1rem;

  li.nav-small {
    a {
      padding: 0;
    }
  }
}

@media only screen and (max-width: 1280px) {
  .nav {
    li.nav-small {
      margin: 0 0.75rem;
    }

    li:not(.nav-small) {
      a {
        padding: 0.5rem;
        margin: 0 0.5rem;

        .nav-txt {
          display: none;
        }
      }

      &[tooltip]::before,
      &[tooltip]::after {
        display: block;
      }
    }
  }

  .nav-meta {
    padding-right: 0;
  }
}
</style>
